import * as Sentry from '@sentry/react';
import posthog from 'posthog-js';

export function initTelemetry() {
  const sentryDsn = process.env.REACT_APP_SENTRY_DSN;
  if (sentryDsn) {
    Sentry.init({
      dsn: sentryDsn,
      environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: 0.1,
    });
  }

  const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
  if (posthogKey) {
    posthog.init(posthogKey, {
      api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
      defaults: '2026-01-30',
      person_profiles: 'identified_only',
      session_recording: { maskAllInputs: true },
    });
  }

  const params = new URLSearchParams(window.location.search);
  if (params.has('debug') || params.get('debug') === '1') {
    localStorage.setItem('eruda', '1');
  } else if (params.get('debug') === '0') {
    localStorage.removeItem('eruda');
  }
  if (localStorage.getItem('eruda')) {
    import('eruda').then(({ default: eruda }) => eruda.init());
  }
}
